import './card-image.scss'
